import { render, staticRenderFns } from "./sidebar-create.vue?vue&type=template&id=79e5956c&scoped=true&"
import script from "./sidebar-create.vue?vue&type=script&lang=js&"
export * from "./sidebar-create.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-create.vue?vue&type=style&index=0&id=79e5956c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e5956c",
  null
  
)

export default component.exports